import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-ag-chord-series-options',
	templateUrl:'./AgChordSeriesPluginCompPage.html',
	styles: [],
	styleUrls:['./AgChordSeriesPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgChordSeriesPluginCompPage
{
	mdContent_705 = `\`\`\`java
import com.jwebmp.plugins.agchartsenterprise.options.series.AgChordSeriesOptions;
\`\`\``;
}
